"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const index_1 = require("../lib/index");
class GraphqlClient {
    constructor(params) {
        if (GraphqlClient.instance) {
            return GraphqlClient.instance;
        }
        else {
            GraphqlClient.instance = this;
        }
        this.params = params;
        this.params.headers = this.params.headers || {};
        params.headers['Content-Type'] = 'application/json';
    }
}
GraphqlClient.instance = null;
exports.GraphqlClient = GraphqlClient;
class GraphqlQuery extends React.Component {
    constructor(props) {
        super(props);
        this.graphqlClient = new GraphqlClient();
        this.state = {
            response: null,
            error: null,
        };
    }
    componentDidMount() {
        const { url, headers } = this.graphqlClient.params;
        index_1.default.post(url, {
            query: this.props.queryString,
            variables: this.props.variables,
        }, headers).subscribe(response => this.setState({ response }), error => this.setState({ error }));
    }
    componentWillReceiveProps(props) {
        if (JSON.stringify(props.variables) === JSON.stringify(this.props.variables)) {
            return;
        }
        const { url, headers } = this.graphqlClient.params;
        index_1.default.post(url, {
            query: props.queryString,
            variables: props.variables,
        }, headers).subscribe(response => this.setState({ response }), error => this.setState({ error }));
    }
    render() {
        const { response, error } = this.state;
        if (!response && !error) {
            return this.props.render(null, null, true);
        }
        return (this.props.render(response && response.response && response.response.data, error, false));
    }
}
GraphqlQuery.defaultProps = {
    variables: {}
};
exports.GraphqlQuery = GraphqlQuery;
//# sourceMappingURL=Grahpql.js.map